import { createElement } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import { App } from './app';
import configureStore from './store';
import setupServiceWorker from './sw';

setupServiceWorker();

// eslint-disable-next-line import/prefer-default-export
export const store = configureStore();

render(createElement(Router, {}, createElement(App, { store })), document.getElementById('root'));
